import Form from '../_form';
import Popup from '../../components/popup';

export default class JobFinishForm extends Form {

    /* eslint-disable no-useless-constructor */
    constructor (query) {
        super(query);

        const reset = this.form.querySelector('.site-button[type="reset"]');

        this.popup = new Popup({
            popup: '.site-popup[data-popup="finish-job"]',
            toggle: '#finish-job-trigger',
            close: '.site-popup-close[data-popup="finish-job"]',
            window: '.site-popup-window[data-popup="finish-job"]'
        });

        reset.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();

            this.popup.close.click();
        });
    }

    async finalizeForm () {
        if (this.submit) this.submit.classList.add('preload');

        const formData = new FormData(this.form);

        const action = formData.get('action');

        try {
            await fetch('/wp-json/jobs/v1/finish', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ action })
            })
            .then((response) => response.json())
            .then((data) => {
                if (data && !data.error) {
                    this.form.classList.remove('error');
                    this.form.classList.add('sent');

                    this.NotificationManager.sendNotification('success', 'Thank you, the job is finished!', data.message);

                    if (this.submit) this.submit.classList.remove('preload');

                    setTimeout(() => window.location.reload(), 3000);
                } else {
                    this.NotificationManager.sendNotification('error', 'An error occurred...', data.message);

                    if (this.submit) this.submit.classList.remove('preload');

                    this.form.classList.add('error');
                }
            })
            .catch(() => {
                this.NotificationManager.sendNotification('error', 'An error occurred...', 'Please, try again');

                if (this.submit) this.submit.classList.remove('preload');

                this.form.classList.add('error');
            });

            this.popup.close.click();
        } catch (error) {
            this.NotificationManager.sendNotification('error', 'An error occurred...', 'Please, try again');

            if (this.submit) this.submit.classList.remove('preload');

            this.form.classList.add('error');

            this.popup.close.click();
        }
    }
}
